<template>
  <base-layout>
    <div class="page-content">
      <v-row>
        <v-col>
          <b>
            Order ID :
          </b>
          {{ billId }}
        </v-col>
        <v-col class="d-flex">
          <b>
            สถานะ :
          </b>
          <div>
            <v-icon :color="displayOrderState(order).color">
              mdi-circle-medium
            </v-icon>
            <span>
              {{ displayOrderState(order).text }}
            </span>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <b>
            Order URL :
          </b>
          <a
            id="linkbill"
            target="_blank"
            :href="fullLinkBill">
            {{ fullLinkBill }}
          </a>
        </v-col>
      </v-row>
      <v-row v-if="displayOrderState(order).text === 'จัดส่งแล้ว'">
        <v-col>
          <b>
            Tacking No. :
          </b>
          {{ order.shippingRefCode }}
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <h1 class="title font-weight-bold">
            รายการสินค้า
          </h1>
        </v-col>
      </v-row>
      <orderItems
        :items="mappedItems"
        :show-btn="false" />
      <v-row class="order-summary">
        <v-col cols="12">
          <h1 class="title font-weight-bold">
            สรุปคำสั่งซื้อ
          </h1>
        </v-col>
        <v-col cols="12">
          <v-row no-gutters>
            <v-col cols="6">
              <label class="pl-4 pt-2 d-block"> ค่าจัดส่ง </label>
            </v-col>
            <v-col
              cols="6"
              class="text-right">
              {{ order.shipCost | showFullPriceFormat() }} บาท
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6">
              <label class="pl-4 pt-2 d-block"> ส่วนลด </label>
            </v-col>
            <v-col
              cols="6"
              class="text-right">
              {{ order.discount | showFullPriceFormat() }} บาท
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="4">
              <label class="pl-4 pt-2 d-block font-weight-bold">
                ยอดสุทธิ
              </label>
            </v-col>
            <v-col cols="8">
              <label class="pl-4 pt-2 d-block text-right font-weight-bold">
                {{ order.net | showFullPriceFormat() }} บาท
              </label>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="order-customer">
        <v-col cols="12">
          <h1 class="title font-weight-bold">
            ข้อมูลลูกค้า
          </h1>
        </v-col>
        <v-col cols="12">
          <v-row no-gutters>
            <v-col cols="4">
              <label class="pl-4 py-2 d-block">
                ชื่อและนามสกุล
              </label>
            </v-col>
            <v-col cols="8">
              <label class="py-2 d-block">{{ order.customerName }}</label>
            </v-col>
            <v-col cols="4">
              <label class="pl-4 py-2 d-block">
                เบอร์ติดต่อ
              </label>
            </v-col>
            <v-col cols="8">
              <label class="py-2 d-block">{{ order.customerTel }}</label>
            </v-col>
            <v-col cols="4">
              <label class="pl-4 py-2 d-block">
                ที่อยู่
              </label>
            </v-col>
            <v-col cols="8">
              <label class="py-2 d-block">{{ order.customerAddress }}</label>
            </v-col>
            <v-col cols="4">
              <label class="pl-4 py-2 d-block">
                ตำบล / แขวง
              </label>
            </v-col>
            <v-col cols="8">
              <label class="py-2 d-block">{{ order.customerSubDistrict }}</label>
            </v-col>
            <v-col cols="4">
              <label class="pl-4 py-2 d-block">
                อำเภอ / เขต
              </label>
            </v-col>
            <v-col cols="8">
              <label class="py-2 d-block">{{ order.customerDistrictCity }}</label>
            </v-col>
            <v-col cols="4">
              <label class="pl-4 py-2 d-block">
                จังหวัด
              </label>
            </v-col>
            <v-col cols="8">
              <label class="py-2 d-block">{{ order.customerStateProvince }}</label>
            </v-col>
            <v-col cols="4">
              <label class="pl-4 py-2 d-block">
                รหัสไปรษณีย์
              </label>
            </v-col>
            <v-col cols="8">
              <label class="py-2 d-block">{{ order.customerPostcode }}</label>
            </v-col>
            <v-col cols="4">
              <label class="pl-4 py-2 d-block">
                Note
              </label>
            </v-col>
            <v-col cols="8">
              <p class="order-note">
                {{ order.note }}
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <div
      v-if="!isBillNotFound"
      class="add-new-item"
      style="justify-content: center; display: flex; flex-wrap: wrap;">
      <v-col class="text-center">
        <v-btn
          v-if="disableEditBtn"
          color="error"
          @click="activeModal = true">
          ลบออร์เดอร์
        </v-btn>
      </v-col>
      <v-col class="text-center">
        <v-btn @click="$router.push('/order')">
          กลับ
        </v-btn>
      </v-col>
      <v-col class="text-center">
        <v-btn
          v-if="displayOrderState(order).text === 'รอแก้ไข'"
          color="warning"
          @click="editOrder">
          แก้ไข
        </v-btn>
      </v-col>
    </div>
    <modalConfirm
      confirm-text="Remove"
      cancel-text="Cancel"
      title="คุณต้องการจะลบ Order นี้หรือไม่ ?"
      :active="activeModal"
      @update:active="activeModal = $event"
      @onConfirm="removeBill()" />
  </base-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import OrderProvider from '@/resources/order.service'
import modalConfirm from '@/components/modal-confirm.vue'
import orderItems from '../components/order-items.vue'

const orderService = new OrderProvider()

export default {
  components: {
    OrderItems: orderItems,
    ModalConfirm: modalConfirm
  },
  data () {
    return {
      linkBill: process.env.VUE_APP_LINK_BILL,
      order: {},
      activeModal: false,
      isBillNotFound: false
    }
  },
  computed: {
    ...mapGetters({
      warehouses: 'Warehouse/warehouse'
    }),
    fullLinkBill () {
      return this.order.url ? `${this.linkBill}/${this.order.url}` : ''
    },
    disableEditBtn () {
      return this.order.note != null && this.order.note !== '' && this.order.currentState
    },
    billId () {
      return this.$route.params.id ? this.$route.params.id : ''
    },
    mappedItems () {
      const items = this.order.items ? this.order.items : []
      // eslint-disable-next-line arrow-body-style
      return items.map((item) => {
        const options = item.concatOptions.split(' ')
        const campWarehouse = this.warehouses.find((warehouse) => warehouse.sellsukiWarehouse === item.warehouse)
        return {
          id: item.id,
          name: item.productName,
          code: item.code,
          variant1: item.variant1,
          variant2: item.variant2,
          option1: options[0] ? options[0] : '',
          option2: options[1] ? options[1] : '',
          price: item.price,
          warehouse: item.warehouse,
          amount: item.amount,
          campWarehouse: campWarehouse.campWarehouse
        }
      })
    },
    mappedOrderShipping () {
      return {
        customerName: this.order.customerName ? this.order.customerName : '',
        customerEmail: this.order.customerName ? this.order.customerEmail : '',
        customerTel: this.order.customerName ? this.order.customerTel : '',
        customerAddress: this.order.customerName ? this.order.customerAddress : '',
        customerSubDistrict: this.order.customerName ? this.order.customerSubDistrict : '',
        customerDistrictCity: this.order.customerName ? this.order.customerDistrictCity : '',
        customerStateProvince: this.order.customerName ? this.order.customerStateProvince : '',
        customerCountry: this.order.customerName ? this.order.customerCountry : '',
        customerPostcode: this.order.customerName ? this.order.customerPostcode : ''
      }
    },
    mappedShippingPrice () {
      return this.order.shipCost ? parseFloat(this.order.shipCost) : 0
    },
    mappedDiscount () {
      return this.order.discount ? parseFloat(this.order.discount) : 0
    }
  },
  async mounted () {
    try {
      this.setLoading({
        active: true,
        clickAble: false,
        message: 'Fetching order.'
      })
      const { data: { bill } } = await orderService.getBillById(this.billId)
      this.order = bill
    } catch (error) {
      this.isBillNotFound = true
    } finally {
      this.setLoading({
        active: false,
        clickAble: false,
        message: 'Fetching order.'
      })
    }
  },
  methods: {
    ...mapActions({
      setLoading: 'Style/setLoading',
      prepareUpdateOder: 'Order/prepareUpdateOder',
      setSnackBar: 'Style/setSnackbar'
    }),
    async removeBill () {
      try {
        this.setLoading({
          active: true,
          clickAble: false,
          message: 'Deleting order.'
        })
        const result = await orderService.removeBill(this.billId)
        if (result) {
          this.setSnackBar({
            value: true,
            message: `ลบ Order ${this.billId}`,
            type: 'success'
          })
        }
        this.$router.go(-1)
      } catch (e) {
        this.setSnackBar({
          value: true,
          message: 'เกิดข้อผิดพลาดจาก Server',
          type: 'error'
        })
      } finally {
        this.setLoading({
          active: false,
          clickAble: false,
          message: 'Deleting order.'
        })
      }
    },
    editOrder () {
      this.prepareUpdateOder({
        bill: this.order,
        shipping: this.mappedOrderShipping,
        items: this.mappedItems,
        shippingPrice: 0,
        discount: {
          type: 'บาท',
          number: 0
        }
      })
      this.$router.push({ name: 'Cart' })
    },
    displayOrderState (bill) {
      const now = new Date()
      const billExpire = new Date(bill.expire)
      if (bill.currentState) {
        switch (bill.currentState) {
          case 'paid':
            return { text: 'จัดส่งแล้ว', color: 'purple' }
          case 'confirmed': {
            if (now - billExpire > 0) {
              return { text: 'หมดอายุ', color: 'grey darken-1' }
            }
            if (bill.note && bill.note !== '') {
              return { text: 'รอแก้ไข', color: 'warning' }
            }
            return { text: 'รอจัดส่ง', color: 'success' }
          }
          default:
            return { text: 'Unknow', color: 'grey darken-4' }
        }
      } else {
        return { text: 'Unknow', color: 'grey darken-4' }
      }
    }
  }
}
</script>

<style>
.status-col {
  position: relative;
}
.status-col span.v-badge__badge {
  top: 50% !important;
  transform: translateY(-50%);
}
button.v-btn:not(.v-btn--outlined).warning {
  color: rgba(0, 0, 0, 0.87);
}
p.order-note {
  white-space: pre-wrap;
}
</style>
